<!-- 个人中心页面 -->
<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心页面</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="姓名">
        <el-input v-model="form.userName"></el-input>
      </el-form-item>

      <el-form-item label="所在门店">
        <el-input v-model="form.shopName"></el-input>
      </el-form-item>

      <el-form-item label="登录账号">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>

      <el-form-item label="登录密码">
        <el-input v-model="form.password"></el-input>
      </el-form-item>
      <!-- 遍历数组生成button -->
      <div style="display: flex; align-items: center; text-align:center" v-if="groupButtonList.length > 0">
        <span>查看报表数据设置：</span>
        <el-button
          v-for="(item, index) in groupButtonList"
          :key="index" size="mini"
          @click="handleGroupButtonClick(item)"
          :type="item.groupValue === dataAuth.groupValue ? 'primary' : 'default'"
        >
          {{ item.groupName }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>
<script >

  export default {
    data() {
      return {
        form: {
          userName: '',
          password: '',
          shopName:'',
          email: '',
          phone: ''
        },
        userId: '',
        dataAuthGroup:{},
        groupButtonList:[],
        dataAuth:{}
      }
    },
    methods: {
       async handleGroupButtonClick(item){
        this.dataAuthGroup.groupValue = item.groupValue;
        this.dataAuthGroup.groupName = item.groupName;
        this.dataAuthGroup.userId = this.userId;
        const {data:res} = await this.$http.post('/dataAuth/edit', this.dataAuthGroup);
        if(res.code === 200){
          this.$message({
            message: '设置成功',
            type: 'success'
          });
        }
      },
      // 加载用户数据权限按钮
      async loadGroupButtonList() {
        const {data:res} = await this.$http.get('/dataAuth/group-list', {params: {userId: this.userId}});
        if(res.code === 200){
          this.groupButtonList=res.data;
        }
      },
      // 加载当前用户已经设置好的数据权限
      async loadUserDataAuth() {
        const {data:res} = await this.$http.get('/dataAuth/get-data-auth', {params: {userId: this.userId}});
        if(res.code === 200) {
          this.dataAuth = res.data;
        }
      }
    },
    created() {
      this.form.shopName = window.sessionStorage.getItem('orgName');
      this.form.userName = window.sessionStorage.getItem('userName');
      this.userId = window.sessionStorage.getItem('userId');
      // this.orgId = window.sessionStorage.getItem('orgId');
      this.form.password = window.sessionStorage.getItem('password');
      this.form.phone = window.sessionStorage.getItem('phone');
      this.loadGroupButtonList();
      this.loadUserDataAuth();
    }
  }
</script>
<style scoped lang="less">




// WEBPACK FOOTER //
// src/components/UserInfo.vue